import SearchFilterRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/Common/SearchFilterRequest";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";

export default class MusicFilterModel implements IFilterModel {
    search: string = '';
    categoryId: number = null;
    isPaid: boolean = null;
    isSleep: boolean = null;
    resetToDefault() {
        this.search = '';
        this.categoryId = null;
        this.isPaid = null;
        this.isSleep = null;
    }
    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        this.isPaid != null && res.push(this.createExactSearch('IsPaid', this.isPaid.toString()));
        this.isSleep != null && res.push(this.createExactSearch('IsSleep', this.isSleep.toString()));
        return res;
    }
    createExactSearch(fieldName: string, value: string): SearchRequest {
        return new SearchRequest({
            FieldName: fieldName,
            SearchValue: value,
            SearchFrom: value,
            SearchTo: value
        });
    }
    toFilterRequest(): SearchFilterRequest {
        const res = new SearchFilterRequest({
            Name: (this.search || '').trim(),
            CategoryId: this.categoryId
        });
        res.Search = this.toSearchRequest();
        return res;
    }
}
